import * as yup from "yup";

export const contactUsValidationSchema = yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  emailId: yup.string().email("Invalid email").required("Email is required"),
  country: yup.string().required("Country is required"),
  phoneNo: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone must be 10 digits only")
    .required("Phone number is required"),
  message: yup.string().required("Message is required"),
});
